import * as z from "zod";
import { FlowDefinitionSchema } from "./schema.js";

/** Canonical URI editors can use to identify the published Flow v2 vocabulary. */
export const FLOW_DEFINITION_JSON_SCHEMA_ID = "https://skaile.ai/schemas/flow/v2.json";

/** Keeps editor tooling downstream of Zod so the checked-in artifact cannot become an authority. */
export function generateFlowDefinitionJsonSchema(): z.core.JSONSchema.JSONSchema {
  return {
    $id: FLOW_DEFINITION_JSON_SCHEMA_ID,
    ...z.toJSONSchema(FlowDefinitionSchema, {
      target: "draft-2020-12",
      io: "input",
      reused: "inline",
    }),
  };
}
